export default __webpack_public_path__ + "static/media/Infinity_24.f813b72f.svg";